// pages/Messages.jsx
import React from "react";
import { BiSearch, BiMessageSquareDetail } from "react-icons/bi";
import { FiSend } from "react-icons/fi";

const Messages = () => {
  return (
    <div className="w-full h-[calc(100vh-80px)] max-w-6xl mx-auto px-4 py-6 flex border border-gray-100 rounded-lg overflow-hidden">
      {/* Left Pane: Conversations */}
      <div className="w-1/3 border-r pr-4">
        <h2 className="text-lg font-bold mb-4">Messages</h2>
        <div className="relative mb-4">
          <input
            type="text"
            placeholder="Find jobs by name or job title"
            className="w-full border border-gray-300 rounded px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-black"
          />
          <BiSearch className="absolute right-3 top-3 text-gray-500" size={18} />
        </div>
        {/* Placeholder for conversations */}
      </div>

      {/* Right Pane: Message Display */}
      <div className="flex-1 flex flex-col items-center justify-center text-center px-6">
        <BiMessageSquareDetail className="text-gray-300 text-6xl mb-4" />
        <p className="text-base font-medium text-gray-800 mb-1">You have no active conversations.</p>
        <p className="text-sm text-[#004349] font-medium cursor-pointer hover:underline">Where are my messages?</p>

        <div className="w-full max-w-xl mt-auto mb-4">
          <div className="relative">
            <input
              type="text"
              disabled
              placeholder="Type a message..."
              className="w-full border rounded-full px-4 py-2 text-sm text-gray-500 bg-gray-100 cursor-not-allowed"
            />
            <FiSend className="absolute right-4 top-2.5 text-gray-400" size={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Messages;
